import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../../components/include/Footer";
import Title from "../../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../../redux/selectors/authSelector";
import { signup, signupClear } from "../../redux/actions/authActions";
import { Link, useNavigate } from "react-router-dom";
import { message } from "../../redux/actions/toastActions";
import Logo from "../../assets/Icons/Frame 476.png";
import "../../styles/Login.scss";
import emailIcon from "../../assets/Icons/email.svg";
import lockIcon from "../../assets/Icons/lock.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import userIcon from "../../assets/Icons/user.svg";
import schoolIcon from "../../assets/Icons/graduate.svg";
import phoneIcon from "../../assets/Icons/world.svg";

const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [email, setEmail] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );
  const [contactNumber, setContactNumber] = useState("");
  const [password, setPassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : ""
  );
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // const [IPAddress, setIPAddress] = useState('')
  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const onSignUpAction = async (event) => {
    
    event.preventDefault();
    // Validate passwords match
    if (password !== confirmPassword) {
      console.log("erore");
      dispatch(message("Passwords do not match")); 
      return;
    }

    // Validate terms accepted
    if (!termsAccepted) {
      dispatch(message("You must accept the Terms & Conditions"));
      return;
    }
    const formData = {
      first_name: firstName,
      last_name: lastName,
      username:username,
      school_name:schoolName,
      email: email,
      mobile: contactNumber,
      password:password,
      isAgreeTC: termsAccepted,
    };

    // Display form data (e.g., in console or alert)
    console.log("Form Data:", formData);
    
    // Dispatch signup action with all fields
    dispatch(signup(formData));
  };

  useEffect(() => {
    dispatch(signupClear());
  }, [dispatch]);

  useEffect(() => {
    if (Authenticated) {
      navigate("/signUp-verify", { state: { email: email } });
      // dispatch(message(loginMessage));
    }
    
  }, [Authenticated]);
  return (
    <>
      <Title name="Sign Up" />
      {console.log("errorMsg =>", errorMsg)}
      <div
        className="account-pages signUpBackground font-fustat"
        style={{ paddingTop: "3%" }}
      >
        <div className="container ">
          <div className="row justify-content-end">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body pt-0">
                  <h3 className="text-center mt-4">
                    <a href="/" className="logo logo-admin">
                      <img src={Logo} height="100" alt="logo" className=" mb-4" style={{ width: "220px" }} />
                    </a>
                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                    <h3>Sign Up</h3>

                    <p className="sub-title">
                      Join now to simplify your school's operations 
                      <br></br>
                      Sign up and get started in minutes!
                    </p>
                  </h3>
                  <div className="login-container " style={{maxWidth:"480px"}}>
                    <form className="login-form" autoComplete="off" onSubmit={onSignUpAction}>
                      <div className="flex  justify-between" >
                        <div>

                        <label>First Name<span className="required">*</span></label>
                        <div className="input-group ">
                          <span className="icon">
                            <img src={userIcon} alt="user icon" />
                          </span>
                         <input
                            type="text"
                            value={firstName}
                            onChange={(e) => {
                              // remove anything that's not a letter or space
                              const onlyLetters = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              setFirstName(onlyLetters);
                            }}
                            placeholder="Enter First Name"
                            required
                          />
                        </div>
                        </div>
                        <div>
                        <label>Last Name<span className="required">*</span></label>

                        <div  className="input-group">
                          <span className="icon">
                            <img src={userIcon} alt="user icon" />
                          </span>
                          <input
                            type="text"
                            value={lastName}
                            onChange={(e) => {
                              // remove anything that's not a letter or space
                              const onlyLetters = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              setLastName(onlyLetters);
                            }}
                            placeholder="Enter Last Name"
                            required
                          />
                        </div>
                        </div>
                      </div>

                      {/* Username */}
                      <label>
                        Username<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={userIcon} alt="user icon" />
                        </span>
                        <input
                          type="text"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Enter Your Username"
                          required
                        />
                      </div>

                      {/* School Name */}
                      <label>
                        School Name<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={schoolIcon} alt="school icon" />
                        </span>
                        <input
                          type="text"
                          value={schoolName}
                          onChange={(e) => setSchoolName(e.target.value)}
                          placeholder="Enter Your School Name"
                          required
                        />
                      </div>

                      {/* Email ID */}
                      <label>
                        Email ID<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={emailIcon} alt="email icon" />
                        </span>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter Your Email ID"
                          autoComplete="new-email"

                          required
                        />
                      </div>

                      {/* Contact Number */}
                      <label>
                        Contact Number<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={phoneIcon} alt="phone icon" />
                        </span>
                      <input
                        type="tel"
                        value={contactNumber}
                        onChange={(e) => {
                          // keep only digits
                          const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                          setContactNumber(onlyNumbers);
                        }}
                        placeholder="Enter Your Contact Number"
                        maxLength={12}
                        required
                      />
                      </div>

                      {/* Password */}
                      <label>
                        Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock icon" />
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter Your Password"
                           autoComplete="new-password"
                          required
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <IoEyeOutline className="icon" />
                          ) : (
                          <IoEyeOffOutline className="icon" />
                          )}
                        </span>
                      </div>

                      {/* Confirm Password */}
                      <label>
                        Confirm Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock icon" />
                        </span>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Enter Your Password"
                           autoComplete="new-password"
                          required
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                          {showConfirmPassword ? (
                            <IoEyeOutline className="icon" />
                          ) : (
                            <IoEyeOffOutline className="icon" />
                          )}
                        </span>
                      </div>
                      {/* <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock icon" />
                        </span>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Confirm Your Password"
                          autoComplete="new-password"
                          required
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                         {showPassword ? (
                            <IoEyeOutline className="icon" />
                          ) : (
                            <IoEyeOffOutline className="icon" />
                          )}
                        </span>
                      </div> */}

                      {/* Checkbox */}
                      <div className="form-check mt-2 mb-2 flex items-center">
                        <input
                          type="checkbox"
                          className="form-check-input transform scale-145 mt-2" 
                          id="termsCheck"
                          checked={termsAccepted}
                          onChange={(e) => setTermsAccepted(e.target.checked)}
                          required
                        />
                        <label htmlFor="termsCheck" className="form-check-label ml-1 mt-[6px]">
                          I agree to the{" "}
                          <a href="#" className="text-secondary_main font-bold">
                            Terms & Conditions
                          </a>{" "}
                          and{" "}
                          <a href="#" className="text-secondary_main font-bold">
                            Privacy Policy
                          </a>.
                        </label>
                      </div>

                      {/* Sign Up Button */}
                      <button
                        type="submit"
                        className="sign-in-button"
                        disabled={loader}
                      >
                        {loader ? "Please wait..." : "Sign Up"}
                      </button>
                    </form>

                    <p className="text-center pt-3 font-sm">
                      Already have an Account?{" "}
                      <Link to="/" className="forgot-password">
                        Sign In
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="mt-5 text-center">
                <Footer />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
